import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyBook from "@/components/StickyBook";
import SmoothScroll from "@/components/SmoothScroll";
import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import Rooms from "@/pages/Rooms";
import RoomDetail from "@/pages/RoomDetail";
import Amenities from "@/pages/Amenities";
import Gallery from "@/pages/Gallery";
import Neighborhood, { NeighborhoodIndex } from "@/pages/Neighborhood";
import ExtendedStay from "@/pages/ExtendedStay";
import AudiencePage from "@/pages/AudiencePage";
import Attractions from "@/pages/Attractions";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import PostEditor from "@/pages/admin/PostEditor";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <div className="grain min-h-screen bg-bone">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <StickyBook />
    </div>
  );
}

function NeighborhoodRoute() {
  const { slug } = useParams();
  return <Neighborhood slug={slug} />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/rooms" element={<PublicLayout><Rooms /></PublicLayout>} />
          <Route path="/rooms/:slug" element={<PublicLayout><RoomDetail /></PublicLayout>} />
          <Route path="/amenities" element={<PublicLayout><Amenities /></PublicLayout>} />
          <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
          <Route path="/near" element={<PublicLayout><NeighborhoodIndex /></PublicLayout>} />
          <Route path="/near/:slug" element={<PublicLayout><NeighborhoodRoute /></PublicLayout>} />
          <Route path="/extended-stay" element={<PublicLayout><ExtendedStay /></PublicLayout>} />
          <Route path="/business-travelers" element={<PublicLayout><AudiencePage slug="business-travelers" /></PublicLayout>} />
          <Route path="/family-travel" element={<PublicLayout><AudiencePage slug="family-travel" /></PublicLayout>} />
          <Route path="/group-travel" element={<PublicLayout><AudiencePage slug="group-travel" /></PublicLayout>} />
          <Route path="/medical-stay" element={<PublicLayout><AudiencePage slug="medical-stay" /></PublicLayout>} />
          <Route path="/attractions" element={<PublicLayout><Attractions /></PublicLayout>} />
          <Route path="/local-guide" element={<PublicLayout><Blog /></PublicLayout>} />
          <Route path="/local-guide/:slug" element={<PublicLayout><BlogPost /></PublicLayout>} />
          <Route path="/faq" element={<PublicLayout><Faq /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/new" element={<PostEditor />} />
          <Route path="/admin/edit/:id" element={<PostEditor />} />
          <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
